import React from 'react';
import css from './TrendingSection.module.css';
import { cardRenderSizes, isArrayLength } from '../../../util/genericHelpers';
import { ListingCard } from '../../../components';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { trendingListingsSelector } from '../SearchPage.duck';

const TrendingSection = () => {
  const trendingListings = useSelector(trendingListingsSelector);

  if (!isArrayLength(trendingListings)) {
    return (
      <div className={css.fixedWidthContainer}>
        <div className={css.emptyState}>
          <h3>
            <FormattedMessage
              id="TrendingSection.noListings"
              defaultMessage="No trending listings available"
            />
          </h3>
        </div>
      </div>
    );
  }

  return (
    <div className={css.fixedWidthContainer}>
      {/* Header */}
      <div className={css.header}>
        <div className={css.iconWrapper}>
          <svg className={css.starIcon} viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
          </svg>
        </div>
        <div className={css.headerText}>
          <h2 className={css.title}>
            <FormattedMessage id="TrendingSection.title" defaultMessage="Trending Now" />
          </h2>
          <p className={css.subtitle}>
            <FormattedMessage
              id="TrendingSection.subtitle"
              defaultMessage="Check out the most popular listings right now."
            />
          </p>
        </div>
      </div>

      {/* Listings Grid */}
      <div className={css.listingGrid}>
        {trendingListings.map(l => (
          <ListingCard
            className={css.listingCard}
            key={l.id.uuid}
            listing={l}
            renderSizes={cardRenderSizes(false)}
          />
        ))}
      </div>
    </div>
  );
};

export default TrendingSection;
